<template>
    <div class="main">
        <div class="page-top">
            <slot name="top"></slot>
        </div>
        <div class="content">
            <slot name="content"></slot>
        </div>
        <div class="page-bottom">
            <slot name="footer"></slot>
        </div>
        <div class="others" v-if="$slots['others']">
            <slot name="others"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageContainer"
    };
</script>

<style scoped lang="scss">
    .main {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /*height: 100%;*/
        width: 100%;
        position: relative;
        .page-top {
            display: flex;
            justify-content: space-between;
            margin: 24px auto 0;
            max-width: 1200px;
            width: 100%;
        }
        .content {
            flex: 1;
            margin-top: 24px;
        }
        .others {
            position: absolute;
            height: 100%;
            width: 100%;
        }
    }
</style>
